import SubPage from "@/layout/SubPage.vue"

export default {
  path: "clinic",
  name: "clinic",
  component: SubPage,
  meta: { title: "门店模块", icon: "dashboard" },
  hidden: true,
  props: true,
  children: [// --- 门店词典 ---
    {
      name: "pharmacy",
      path: "pharmacy",
      component: SubPage,
      meta: { title: "药房管理", icon: "dashboard" },
      hidden: true,
      props: true,
      children: [{
        name: "subpharmacy",
        path: "pharmacy",
        component: SubPage,
        meta: { title: "药房管理", icon: "dashboard" },
        hidden: true,
        props: true,
        children: [{
          name: "Cooperation",
          meta: { title: "签约信息", icon: "dashboard" },
          path: "Cooperation/:viewMode/:mode",
          component: () => import("@/views/business/page/manager/pharmacy/Cooperation/Cooperation.vue"),
          hidden: true,
          props: true
        }, {
          name: "Medicine",
          meta: { title: "药品信息", icon: "dashboard" },
          path: "Medicine/:viewMode/:mode",
          component: () => import("@/views/business/page/manager/pharmacy/pharmacy/Medicine.vue"),
          hidden: true,
          props: true
        }, {
          name: "Nutraceuticals",
          meta: { title: "保健品信息", icon: "dashboard" },
          path: "Nutraceuticals/:viewMode/:mode",
          component: () => import("@/views/business/page/manager/pharmacy/pharmacy/Nutraceuticals.vue"),
          hidden: true,
          props: true
        }, {
          name: "DecoctingFee",
          meta: { title: "代煎费用", icon: "dashboard" },
          path: "DecoctingFee/:viewMode/:mode",
          component: () => import("@/views/business/page/manager/pharmacy/pharmacy/DecoctingFee.vue"),
          hidden: true,
          props: true
        }, {
          name: "Storage",
          meta: { title: "库存信息", icon: "dashboard" },
          path: "Storage/:viewMode/:mode",
          component: () => import("@/views/business/page/manager/pharmacy/Storage/Storage.vue"),
          hidden: true,
          props: true
        }, {
          name: "StorageStatement",
          meta: { title: "库存流水", icon: "dashboard" },
          path: "StorageStatement/:viewMode/:mode",
          component: () => import("@/views/business/page/manager/pharmacy/Storage/StorageStatement.vue"),
          hidden: true,
          props: true
        }, {
          name: "SaleOrd",
          meta: { title: "代售处方", icon: "dashboard" },
          path: "SaleOrd/:viewMode/:mode",
          component: () => import("@/views/business/page/manager/pharmacy/Decocting/SaleOrd.vue"),
          hidden: true,
          props: true
        }, {
          name: "DecoctingOrd",
          meta: { title: "代煎处方", icon: "dashboard" },
          path: "DecoctingOrd/:viewMode/:mode",
          component: () => import("@/views/business/page/manager/pharmacy/Decocting/DecoctingOrd.vue"),
          hidden: true,
          props: true
        }, {
          name: "CooperationMedicine",
          meta: { title: "签约药品", icon: "dashboard" },
          path: "CooperationMedicine/:viewMode/:mode",
          component: () => import("@/views/business/page/manager/pharmacy/Cooperation/CooperationMedicine.vue"),
          hidden: true,
          props: true
        }, {
          name: "CooperationNutraceuticals",
          meta: { title: "签约保健品", icon: "dashboard" },
          path: "CooperationNutraceuticals/:viewMode/:mode",
          component: () => import("@/views/business/page/manager/pharmacy/Cooperation/CooperationNutraceuticals.vue"),
          hidden: true,
          props: true
        }, {
          name: "CooperationDecoctingFee",
          meta: { title: "签约代煎服务", icon: "dashboard" },
          path: "CooperationDecoctingFee/:viewMode/:mode",
          component: () => import("@/views/business/page/manager/pharmacy/Cooperation/CooperationDecoctingFee.vue"),
          hidden: true,
          props: true
        }, {
          name: "AgentStlmt",
          meta: { title: "代售结算单", icon: "dashboard" },
          path: "AgentStlmt/:viewMode/:mode",
          component: () => import("@/views/business/page/manager/pharmacy/Decoctingstlmt/AgentStlmt.vue"),
          hidden: true,
          props: true
        }, {
          name: "shagentstlmt",
          meta: { title: "代煎结算单", icon: "dashboard" },
          path: "shagentstlmt/:viewMode/:mode",
          component: () => import("@/views/business/page/manager/pharmacy/Decoctingstlmt/shagentstlmt.vue"),
          hidden: true,
          props: true
        }]
      }]
    }
  ]
}
